import cn from 'classnames';

import { stripSpecialChars } from 'helpers';
import { parseAndCleanHtmlToReact } from 'helpers/HtmlHelpers';
import LandingPageLink from 'components/landing/LandingPageLink';
import LandingPageImage from 'components/landing/LandingPageImage';

import css from 'styles/components/landing/melodyArticleImages.scss';

function makeHeading(heading) {
  return heading && <h3>{heading}</h3>;
}

function makeBody(body) {
  return body && parseAndCleanHtmlToReact(body);
}

function makeImages(images, onLandingComponentClick, shouldLazyLoad, slotIndex) {
  if (images && images.length > 0) {
    const articleImages = images.map((image, index) => {
      const { src, link, alt, gae, copy } = image;
      const linkProps = {
        'key': `${stripSpecialChars(link)}_${index}`,
        'onClick': onLandingComponentClick,
        'data-eventlabel': 'melodyArticleImages',
        'data-eventvalue': gae,
        'data-slotindex': slotIndex
      };
      const contents = (
        <figure className={cn(css.articleImage, { [css.singleImage]: images.length === 1 })} key={`${stripSpecialChars(src)}_${index}`}>
          <LandingPageImage src={src} alt={alt} shouldLazyLoad={shouldLazyLoad} />
          <figcaption>{copy}</figcaption>
        </figure>
      );
      return link
        ?
        <LandingPageLink key={link} url={link} {...linkProps}>
          {contents}
        </LandingPageLink>
        :
        contents;
    });

    return (
      <div className={css.articleImagesWrap}>
        {articleImages}
      </div>
    );
  }
}

const MelodyArticleImages = ({ slotName, slotIndex, slotDetails, onLandingComponentClick, shouldLazyLoad }) => {
  const { images, heading, body, monetateId } = slotDetails;
  return (
    <article
      className={css.wrap}
      data-slot-id={slotName}
      data-monetate-id={monetateId}
    >
      {makeHeading(heading)}
      {makeBody(body)}
      {makeImages(images, onLandingComponentClick, shouldLazyLoad, slotIndex)}
    </article>
  );
};

export default MelodyArticleImages;
